import axios from 'axios';
var LocalAxios = axios.create();


//services
import LocalStorageService from './LocalStorageService'; var ls = LocalStorageService;
import Helper from './Helper'; var help = Helper;

var RemoteAxios = help.deepClone(axios).create();
var header_withToken = {
    "Content Type": "application/json",
    "Authorization": ls.getToken()
};
var header_withoutToken = {
    "Content Type": "application/json"
}


var AxiosService = {
    getMe,
    postMe,
    postMeURLEncoded,
    getMeLocal
}

function getMe(url, no_token_needed = 0) {
    let header;
    header = header_withToken;
    if (no_token_needed) {
        header = header_withoutToken;
    }
    else {
        header = {
            ...header_withToken
        }
        RemoteAxios.defaults.headers.common['Authorization'] = ls.getToken();
    }
    return RemoteAxios.get(url, {
        header: header
    });
}

function postMe(url, obj, no_token_needed = 0) {
    let header;
    header = header_withToken;
    if (no_token_needed) {
        header = header_withoutToken;
    }
    else {
        RemoteAxios.defaults.headers.common['Authorization'] = ls.getToken();
    }
    return RemoteAxios.post(url, obj, {
        header: header
    });
}

function postMeURLEncoded(url, obj) {
    // return LocalAxios.post(url, obj, {
    //     header: {
    //         'Content-Type': 'application/x-www-form-urlencoded'
    //     }
    // });
    return fetch(url, {
        method: 'post',
        body: obj,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(res => {
        return res.text()
        .then(text_res => {

            return JSON.parse(filterLocalResponse(text_res));
        })
    });

}
function getMeLocal(url) {
    return fetch(url, {

    }).then(res => {
        return res.text()
            .then(text_res => {

                return JSON.parse(filterLocalResponse(text_res));
            })

    });

}

function filterLocalResponse(str) {
    let res = "";
    if (str && str.length) {
        for (let i = 0; i < str.length; i++) {
            if (help.isASCII(str.charAt(i))) {
                res = res + str.charAt(i);
            }
            else {
                res = res + '';
            }
        }
    }
    return res;
}

export default AxiosService;



// WEBPACK FOOTER //
// ./services/AxiosService.js